import React from 'react';
import { primaryTextColor } from '../../themes/index';

function PushPin({ fill = primaryTextColor, width = 16, height = 16, style }) {
  return (
    <svg style={style} width={width} height={height} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_2_12094)">
        <path d="M9.87899 10.4205L9.95152 12.3431L9.23218 13.0377L6.80087 10.52L3.91153 13.3103L3.20453 13.2979L3.21687 12.5909L6.10622 9.80071L3.67491 7.28302L4.39425 6.58836L6.24361 6.656L10.224 2.81223L9.64508 2.21278L10.3644 1.51812L15.1576 6.48156L14.4382 7.17622L13.8593 6.57677L9.87899 10.4205ZM5.33204 7.55947L8.94426 11.3L8.92058 9.95591L13.1647 5.85743L10.9186 3.53157L6.67452 7.63005L5.33204 7.55947Z" fill={fill} />
      </g>
      <defs>
        <clipPath id="clip0_2_12094">
          <rect width={width} height={height} fill={fill} />
        </clipPath>
      </defs>
    </svg>

  );
}

export default PushPin;
